import { urlToBase64 } from  'src/app/utils/common.utils';
import * as moment from "moment-timezone";
import { TitleCasePipe, UpperCasePipe } from '@angular/common';

export async function isiReportDownload(data:any, user:any,configuration:any, preLevelOfService:any, selectedCorporate:any, source:any) {
  const invoiceNumber  = configuration.invoiceNo;
  const urlBase64 = user.profileImageURL
    ? await urlToBase64(user.profileImageURL)
    : "";

  const sortedData = (data).sort(
    (a:any, b:any) => moment(a?.pickup?.time).valueOf() - moment(b?.pickup?.time).valueOf()
  );

  //  ..calculate total fare 
  let totalFare = sortedData?.reduce((sum:any, trip:any) => {
    let fare = 0;
    if (source === 'fundingsourceBilling') {
      fare = parseFloat(trip?.fare?.breakdown?.total) || 0;
    } else {
      fare = (trip?.specialRate && trip.specialRate > 0)
        ? trip.specialRate
        : parseFloat(trip?.offeredFare?.total) || 0;
    }
    return sum + fare;
  }, 0);

  // Build rows dynamically
  const upperCase = new UpperCasePipe();
  const titleCase = new TitleCasePipe();
  const tripRows = sortedData?.map((trip:any, index:any) => [
    { text: moment(trip?.pickup?.time).format('MM-DD-YYYY'), fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    { text: titleCase.transform(trip?.member?.displayName) , fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    {
      stack: [
        { text: [{ text: "Vehicle ID: ", bold: true }, trip?.vehicle?.vin] },
        { text: [{ text: "Driver: ", bold: true }, trip?.driver?.displayName]}
      ],
      fontSize: 9,
      fillColor: index % 2 === 0 ? "#ededed" : null,
    },
    
    // { text: preLevelOfService && preLevelOfService[trip.levelOfService] ? preLevelOfService[trip.levelOfService].title : 'N/A', fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    { text: (upperCase.transform(trip?.levelOfService?.title)) || 'N/A', fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    { text: trip?.member?.medicalRecordNumber || 'N/A', fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    {
      stack: [
        { text: [{ text: "Trip ID: ", bold: true }, trip?.reference +'-'+ trip.suffix] },
        { text: [{ text: "PU: ", bold: true }, trip?.pickup?.address?.name] },
        { text: [{ text: " PU Time: ", bold: true },trip?.pickup?.time ? moment(trip?.pickup?.time).format("HH:mm") : "N/A"]},
        { text: [{ text: "DO: ", bold: true }, trip?.destination?.address?.name] },
        { text: [{ text: " DO Time: ", bold: true }, moment(trip.destination?.time).format("HH:mm")]},
        { text: [{ text: "Notes: ", bold: true }, `${trip?.member?.generalNotes?.slice(0,30) || 'N/A'}`] },
        { text: [{ text: "Distance: ", bold: true }, `${trip?.offeredFare?.breakdown?.distance || 0} mi`] }
      ],
      fontSize: 9,
      lineHeight: 1,
      fillColor: index % 2 === 0 ? "#ededed" : null,
    },

    {text:source === 'fundingsourceBilling' ? (trip?.fare?.breakdown?.total ? `$${trip.fare.breakdown.total}` : `$0`) : ((trip?.specialRate && trip.specialRate > 0) ? `$${trip.specialRate}` : (trip?.offeredFare?.total ? `$${trip.offeredFare.total}` : `$0`)),
    fontSize: 9,
    fillColor: index % 2 === 0 ? "#ededed" : null
    }

  ]);

  // Split trips into chunks of 4 per page
  const chunkSize = 4;
  const tripTables = [];
  for (let i = 0; i < tripRows?.length; i += chunkSize) {
    tripTables.push({
      style: "tableStyle",
      table: {
        headerRows: 1,
        widths: [50, 60, 70, 60, 60, "*", 50],
        body: [
          [
            { text: "Date", bold: true, fontSize: 8 },
            { text: "Passenger Info", bold: true, fontSize: 8 },
            { text: "Driver Info", bold: true, fontSize: 8 },
            { text: "Trip Mode", bold: true, fontSize: 8 },
            { text: "Member ID", bold: true, fontSize: 8 },
            { text: "Trip Info", bold: true, fontSize: 8 },
            { text: "Amount", bold: true, fontSize: 8 }
          ],
          ...tripRows.slice(i, i + chunkSize)
        ]
      },
      layout: {
        hLineWidth: (i:any, node:any) => (i === 0 ? 0 : 0.5),
        vLineWidth: () => 0,
        hLineColor: () => "#cccccc",
      },
      pageBreak: i + chunkSize < tripRows.length ? "after" : undefined, // add page break
      margin: [0, 50, 0, 0],
    });
  }

  return {
    pageSize: { width: 595.28 + 100, height: 841.89 },
    defaultStyle: { fontSize: 8},
    content: [
         {
      columns: [
       
       	{
			image: urlBase64,
			 width: 100,
			height: 60,
		},
    
        { text: user.name,fontSize: 16, alignment:'center', bold: true, width: '70%' }, 

        {
          stack: [
            { text: "INVOICE", fontSize: 16, bold: true, margin: [0, 0, 0, 4] },
            { text: `Invoice No: ${invoiceNumber}`, fontSize: 8,lineHeight: 1.1, },
            { text: `Invoice Date: ${configuration?.invoiceDate ? moment(configuration.invoiceDate).tz(user.timeZone).format('MM-DD-YYYY') : moment().tz(user.timeZone).format('MM-DD-YYYY')}`, fontSize: 8 ,lineHeight: 1.1,},
            { text: `Invoice Due Date: ${configuration?.dueDate ? moment(configuration.dueDate).tz(user.timeZone).format('MM-DD-YYYY') : moment().tz(user.timeZone).add(1, 'week').format('MM-DD-YYYY')}`,fontSize: 8,lineHeight: 1.1,}
          ],
          alignment: 'left',
          width: '20%'
        }

      ]
    },
    // --- Client ---
    {
  margin: [0, 15, 0, 0],
  columns: [
    {
      stack: [
        {
          columns: [
            { text: "To: ", bold: true, width: 30 },
            {
              stack: [
                { text: titleCase.transform(configuration?.billingCompany) || '', fontSize: 8},
                { text: configuration?.billingAddress || '', fontSize:8, margin: [0, 2, 0, 0] }
              ],
      //            stack: [
      //   {
      //     columns: [
      //       { text: "Client: ", bold: true, width: 30 },
      //       {
      //         stack: [
      //           { text: selectedCorporate.displayName, fontSize: 8},
      //           { text: selectedCorporate.address, fontSize:8, margin: [0, 2, 0, 0] }
      //         ],
      //         width: '*'
      //       }
      //     ]
      //   }
      // ],
              width: '*'
            }
          ]
        }
      ],
      width: '*',
    //   alignment: ''
    }
  ]
},
      ...tripTables, 


    // --- Totals section ---
    {
      columns: [
        { text: '', width: '*' }, 
        {
          width: 'auto',
          stack: [
            // { text: [ { text: 'Total Items/Corrections: ', bold: true }, configuration.corrections ], alignment: 'right' },
            {
              text: [
                { text: 'Subtotal: ', bold: true },
                `$${totalFare.toFixed(2)}`
              ],
              alignment: 'right',
              margin: [0, 5, 0, 0]
            },
            {
              text: [
                { text: 'Total: ', bold: true },
                `$${totalFare.toFixed(2)}`
              ],
              alignment: 'right',
              fontSize: 11,
              margin: [0, 10, 0, 0]
            }

          ]
        }
      ],
      margin: [0, 30, 0, 20],
    },
    // --- Outstanding Invoices Heading ---
    { text: 'Outstanding Invoices', bold: true, fontSize: 11, margin: [0, 0, 0, 5] },
    { canvas: [ { type: 'line', x1: 0, y1: 0, x2: 620, y2: 0, lineWidth: 1 } ], margin: [0, 0, 0, 5] },
    // --- Outstanding Invoices Row ---
    {
  columns: [
    { text: `Invoice No.: ${configuration.outstandingInvoiceNo}` },
    // { text: `Invoice Dueee Date: ${configuration?.dueDate ? moment(configuration.dueDate).tz(user.timeZone).format('MM-DD-YYYY') : moment().tz(user.timeZone).add(1, 'week').format('MM-DD-YYYY')}`},
    {
      stack: [
        {
          columns: [
            { text: 'Past Due', color: 'red', bold: true, margin: [0, 0, 28, 0] },
            {
              text: configuration.pastDue > 0
                ? `Balance: $${configuration.pastDue.toFixed(2)}`
                : `Balance: $${configuration.pastDue}`,
              alignment: 'right'
            }
          ]
        }
      ],

      width: 'auto',
      alignment: 'right'
    }
  ],
  margin: [0, 0, 0, 20],
},

    // --- Balances (Right Side) ---
    {
      columns: [
        { text: '', width: '*' },
        {
          width: 'auto',
          stack: [
            {
              text: [
                { text: 'Current Balance: ', bold: true },
                `$${totalFare.toFixed(2)}`
              ],
              alignment: 'right',
              margin: [0, 5, 0, 0]
            },
            {
              text: [
                { text: 'Total Balance: ', bold: true },
                (totalFare + parseInt(configuration.pastDue)) > 0
                  ? `$${(totalFare + parseInt(configuration.pastDue)).toFixed(2)}`
                  : (totalFare + parseInt(configuration.pastDue)).toFixed(2)
              ],

              alignment: 'right',
              fontSize: 11,
              margin: [0, 10, 0, 0]
            }

          ]
        }
      ]
    },
    ],

    
  footer: function (currentPage:any, pageCount:any) {
    return {
      margin: [40, -50, 40, 0],
      stack: [
        {
          columns: [
            {
              width: '70%',
              stack: [
                { text: "DIRECT ALL INQUIRIES TO:", bold: true, fontSize: 9 },
                { text: user.name, fontSize: 8, margin: [0, 2, 0, 0] },
                { text: user.phoneNumber ? user.phoneNumber : 'N/A', fontSize: 8 },
                { text: user.email, fontSize: 8 }
              ],
              alignment: 'left'
            },
            {
              width: '30%',
              stack: [
                { text: "MAKE ALL CHECKS PAYABLE TO:", bold: true, fontSize: 9 },
                { text: titleCase.transform(configuration.billingCompany), fontSize: 8, margin: [0, 2, 0, 0]},
                { text: configuration.billingAddress
                  , fontSize: 8, margin: [0, 2, 0, 0]},
                { text: configuration.billingCompanyPhone, fontSize: 8 }
              ],
              alignment: 'left'
            }
          ]
        },
        {
          columns: [
            { text: "Powered by NEMT Platform", alignment: 'left', fontSize: 8, margin: [0, 10, 0, 0], italics: true },
            { text: `Page  ${currentPage} of ${pageCount}`, alignment: 'right', fontSize: 8, margin: [0, 10, 0, 0] }
          ]
        }
      ]
    };
  }
  };
}
